import React from 'react';
import styles from './styles.module.scss';
import DateTimeFormat from '../DateTimeFormat';

const ShowPatientConsentTable = ({ patientConsentData }) => (
  <div>
    <table className={styles.patientConsentTable}>
      <tbody>
        <tr>
          <th>
            Allow Teladoc providers and your<br/>
            existing doctors to share records<br/>
            with each other
          </th>
          <td>{patientConsentData.answer === 'Y' ? 'Yes' : 'No'}</td>
        </tr>
        <tr>
          <th>Date</th>
          <td><DateTimeFormat dateString={patientConsentData.approval_date} /></td>
        </tr>
        <tr>
          <th>Source</th>
          <td>{patientConsentData.source}</td>
        </tr>
      </tbody>
    </table>
  </div>
)

export default ShowPatientConsentTable;